<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import { buildSettingsSections } from 'dashboard/components-next/topbar/adminNavSections';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const { t } = useI18n();
const route = useRoute();
const { accountScopedRoute } = useAccount();

// Rodada mobile: no celular nao ha o dropdown de Config do topo, entao as
// secoes viram chips horizontais no topo da area de settings (so < md).
const settingsItems = computed(() =>
  buildSettingsSections({ t, accountScopedRoute }).flatMap(
    section => section.items
  )
);

const isItemActive = item => item.link?.name === route.name;
</script>

<template>
  <!-- overflow-y-auto AQUI (e nao nos filhos): o scroll oficial do painel fica
       numa barra so, colada na borda direita. O padding fica num filho INTERNO
       de proposito: padding no proprio container de scroll vira uma faixa fixa
       por onde o conteudo rolado "vaza" acima do header sticky. -->
  <div
    class="flex flex-col w-full h-full m-0 overflow-y-auto slim-scrollbar bg-n-surface-1 font-inter"
  >
    <div
      class="md:hidden sticky top-0 z-20 flex gap-1.5 overflow-x-auto px-3 py-2 bg-n-surface-1 border-b border-n-weak"
    >
      <router-link
        v-for="item in settingsItems"
        :key="item.link?.name || item.label"
        :to="item.link"
        class="flex items-center gap-1.5 flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-medium border transition-colors"
        :class="
          isItemActive(item)
            ? 'bg-n-brand/10 border-n-brand/40 text-n-brand'
            : 'bg-n-solid-1 border-n-weak text-n-slate-11'
        "
      >
        <span :class="item.icon" class="size-3.5 flex-shrink-0" />
        <span class="whitespace-nowrap">{{ item.label }}</span>
      </router-link>
    </div>
    <div class="flex flex-col min-h-full p-6 sm:py-8 lg:px-16">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" />
        </keep-alive>
        <component :is="Component" v-else />
      </router-view>
    </div>
  </div>
</template>
